'use client'

import { useMandatoryContext } from '@repo/hooks'
import { createContext, type PropsWithChildren } from 'react'

export interface UtilityContextProps {
  countryCode?: string | null
}

export const UtilityContext = createContext<UtilityContextProps | null>(null)

/**
 * Hook to access utility context with server-side data like country code.
 * @returns Utility context with country code
 * @throws Error if used outside UtilityContextProvider
 */
export const useUtilityContext = () => {
  return useMandatoryContext(UtilityContext, 'UtilityContext')
}

export interface UtilityContextProviderProps extends PropsWithChildren {
  countryCode?: string | null
}

const UtilityContextProvider = ({ children, countryCode }: UtilityContextProviderProps) => {
  return (
    <UtilityContext.Provider
      value={{
        countryCode
      }}
    >
      {children}
    </UtilityContext.Provider>
  )
}

export default UtilityContextProvider
